module.exports = __webpack_public_path__ + "img/syc.e6584421.svg";